import React, { Component } from 'react';
import { Home } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { DjayAvatar } from '../../mascot';
import { BaseErrorBoundary, ErrorFallbackProps } from './BaseErrorBoundary';
interface GlobalErrorBoundaryProps {
  children: React.ReactNode;
  onNavigateHome?: () => void;
}
/**
 * GlobalErrorBoundary — Catches rendering errors across the entire app shell.
 * Djay-styled fallback for a friendly, on-brand error experience.
 */
export class GlobalErrorBoundary extends Component<GlobalErrorBoundaryProps> {
  handleGoHome = (): void => {
    this.props.onNavigateHome?.();
  };
  renderFallback = ({
    error,
    onReset
  }: ErrorFallbackProps): React.ReactNode => {
    return <div className="max-w-md mx-auto mt-12 px-4" data-id="element-1996">
        <Card className="p-8 sm:p-10 text-center bg-gradient-to-br from-orange-50 to-amber-50 border-2 border-orange-100 shadow-xl rounded-[2rem] relative overflow-hidden" data-id="element-1997">
          <div className="absolute top-0 right-0 w-48 h-48 bg-white/40 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4" data-id="element-1998" />

          <div className="relative z-10 flex flex-col items-center" data-id="element-1999">
            <div className="mb-4" data-id="element-2000">
              <DjayAvatar size="lg" emotion="thinking" variant="default" animate data-id="element-2001" />
            </div>

            <h2 className="text-2xl sm:text-3xl font-black text-slate-800 mb-2 tracking-tight" data-id="element-2002">
              Oeps, dat ging mis!
            </h2>
            <p className="text-slate-600 mb-6 text-base leading-relaxed font-medium max-w-sm" data-id="element-2003">
              Geen zorgen — ga terug naar het dashboard en probeer het opnieuw.
              🚀
            </p>

            {process.env.NODE_ENV === 'development' && error && <div className="mb-6 p-3 bg-rose-50 rounded-xl border border-rose-200 text-left w-full" data-id="element-2004">
                <p className="text-[10px] font-bold text-rose-800 mb-1 uppercase tracking-wider" data-id="element-2005">
                  Debug
                </p>
                <p className="text-xs font-mono text-rose-700 break-all" data-id="element-2006">
                  {error.message}
                </p>
              </div>}

            <Button onClick={() => {
            onReset();
            this.handleGoHome();
          }} variant="primary" size="lg" className="shadow-lg rounded-2xl hover:shadow-xl transition-shadow w-full sm:w-auto" data-id="element-2007">
              <Home className="w-5 h-5 mr-2" data-id="element-2008" />
              Naar dashboard
            </Button>
          </div>
        </Card>
      </div>;
  };
  render(): React.ReactNode {
    return <BaseErrorBoundary logPrefix="Global" fallback={this.renderFallback} data-id="element-2009">
        {this.props.children}
      </BaseErrorBoundary>;
  }
}